import React from "react";
import AdminAddContact from "../../Components/Admin/AdminAddContact";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddContactPage = ()=>{
    return (
      <AdminAddContact />
    )
}

export default AdminAddContactPage;